import React, { FormEvent, useCallback, useEffect, useState } from "react";
import SplitForm from "../../../components/SplitForm";
import PhoneNumberInput from "../../../components/Inputs/PhoneNumberInput";
import SquareButton from "../../../components/Buttons/SquareButton";
import {
  snowTokenSupplier,
  tokenSupplier,
} from "../../../services/axios/webAuth";
import axios from "../../../services/axios/backendAxios";
import errors from "../../../services/errors";
import { useNavigate, useSearchParams } from "react-router-dom";
import collectFormData from "../../../utils/form";
import { cleanPhoneNumber } from "../SignUpPage";
export default function SnowAuthPage() {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const phoneNumber = searchParams.get("phoneNumber");
  const [checkingAuth, setCheckingAuth] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Request a code from the backend
  const onFormSubmit = useCallback(
    async (e: FormEvent) => {
      setLoading(true);
      try {
        setErrorMessage(null);
        e.preventDefault();
        const form = collectFormData<{ phone?: string }>(e.nativeEvent);
        if (typeof form.phone === "string" && form.phone.length > 3) {
          const cleanedNumber = cleanPhoneNumber(form.phone);
          const result = await snowTokenSupplier.requestCode(cleanedNumber);
          if (result.ok) {
            navigate(
              "/login/v2/verify?phoneNumber=" +
                encodeURIComponent(cleanedNumber),
            );
          } else {
            const errorId = await errors.report("Unable to request code", {
              error: result.error,
            });
            setErrorMessage(
              (result.error.message ??
                `Error requesting code: ${result.error.code}`) +
                (errorId ? ` - ${errorId}` : ""),
            );
            console.log("going to report error");
            errors.report(result.error, {
              action: "Error requesting login code",
            });
          }
        }
      } finally {
        setLoading(false);
      }
    },
    [navigate],
  );

  useEffect(() => {
    const abortController = new AbortController();
    tokenSupplier.getToken().then((t) => {
      if (t !== null) {
        console.log("Checked auth and the user is already logged in");
        axios
          .get("/user/me", { signal: abortController.signal })
          .then((r) => {
            console.log(
              "Checked and we have a user in the database that matches our uid",
              r.data.user,
            );
            navigate("/admin");
          })
          .catch((err) => {
            if (errors.isAxiosAbort(err)) {
              // Request aborted, do nothing
            } else if (err.response?.status === 404) {
              navigate("/sign-up"); // we are logged in but don't have a database user yet
            } else {
              errors
                .report(err, {
                  action: "Checking that we have a database user",
                })
                .then((errorId) => {
                  alert(
                    `Oops, we couldn't load your database user. Please email support@mysnowscape.com and send them this error id: ${errorId}`,
                  );
                });
            }
          });
      } else {
        console.log("Checked auth and the user is not logged in");
        setCheckingAuth(false);
      }
    });
    return () => {
      abortController.abort();
    };
  }, [navigate]);
  return (
    <>
      <SplitForm leftContent={null}>
        <div className="grid h-full">
          <div className="text-full-white place-self-center max-w-[500px]">
            {checkingAuth ? (
              <h1>Checking your authentication status...</h1>
            ) : (
              <form onSubmit={onFormSubmit} className="validate-code-form p-2">
                <h1 className="text-2xl lg:text-3xl font-bold">Login</h1>
                <p>
                  Looks like you had some trouble logging in. Please use the
                  form below to try again.
                </p>
                <PhoneNumberInput
                  name="phone"
                  required
                  setValue={undefined}
                  testId={undefined}
                  className={undefined}
                  defaultValue={phoneNumber ?? undefined}
                  value={undefined}
                  autoFocus={undefined}
                  showValidation={undefined}
                  disabled={undefined}
                />
                {errorMessage ? (
                  <div
                    className="text-snow-red p-2"
                    data-testid="sign-up-page-error-message"
                  >
                    {errorMessage}
                  </div>
                ) : null}

                <SquareButton
                  label="Send Code"
                  className="max-w-none"
                  testId="snow-send-code"
                  type="submit"
                  onClick={undefined}
                  disabled={loading}
                  loading={loading}
                  loaderColor={undefined}
                  loaderSize={undefined}
                >
                  Send Code
                </SquareButton>
              </form>
            )}
          </div>
        </div>
      </SplitForm>
    </>
  );
}
